import React, { Component, useState } from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import PropTypes from 'prop-types'
import serviceText from '../../../../config/service-variant-text.json'
import ServiceInformationQuickView from '../../../ServiceInformation/ServiceInformationQuickView'

import { by } from '../../../../utils'

import * as Styled from './ServicePicker.styles'

export class ServicePicker extends Component {
  render() {
    const { type, partNumber, combinationsGroupedByType, selectPartNumber, value } = this.props
    const hasServiceLink = !!combinationsGroupedByType.Installation

    const uniq = Object.keys(combinationsGroupedByType).map(gvalue => {
      if (gvalue === value) {
        return combinationsGroupedByType[value].find(combination => combination.partNumber === partNumber)
      }

      const exactChoices = combinationsGroupedByType[gvalue].filter(combination => !combination.otherCombination)
      if (exactChoices.length) {
        return exactChoices[0]
      }
      // adds disabled property for default combination this prevents the service from being selectable on colour variants that don't provide it.
      combinationsGroupedByType[gvalue][0].disabled = true
      return combinationsGroupedByType[gvalue][0]
    })

    return (
      <Styled.Container>
        <Styled.Options>Choose an option</Styled.Options>
        <span>How would you like to get your item?</span>
        <Styled.ServiceContainer>
          <ServicePickerOptionList {...{ type, partNumber, combinations: uniq, selectPartNumber }} />
          {hasServiceLink && <ServiceInformationLink />}
        </Styled.ServiceContainer>
      </Styled.Container>
    )
  }
}

ServicePicker.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  partNumber: PropTypes.string.isRequired,
  combinationsGroupedByType: PropTypes.array.isRequired,
  selectPartNumber: PropTypes.func.isRequired
}
const ServicePickerOptionList = props => {
  const { type, partNumber: rootPartNumber, combinations, selectPartNumber } = props
  const options = combinations
    .filter(combination => combination.partNumber)
    .filter(combination => combination.attributes.find(by.typeOf(type))) // Defensive code for variants missing attributes
    .map(combination => {
      const { attributes, price, partNumber } = combination
      const { value } = attributes.find(by.typeOf(type))

      return {
        disabled: combination.disabled || false,
        label: serviceText[value].title,
        description: serviceText[value].description,
        id: `serviceRadio-${partNumber}`,
        rightHandElement: <span>{`(£${parseFloat(price).toFixed(2)})`}</span>,
        dataTest: `serviceRadio-${value}`
      }
    })
    .sort((optionOne, optionTwo) => optionOne.label.localeCompare(optionTwo.label)) // ensures that the radiolist options are always rendered in the same order

  return (
    <Styled.ServiceRadioList
      options={options}
      defaultOption={`serviceRadio-${rootPartNumber}`}
      onClick={id => {
        const partNumberToGo = id.split('-')[1]
        selectPartNumber(partNumberToGo)()
      }}
      border
    />
  )
}

const ServiceInformationLink = () => {
  const [show, setShow] = useState(false)
  const toggleCallback = () => setShow(!show)

  return (
    <ErrorBoundary>
      <Styled.Link role='link' tabIndex='0' onClick={toggleCallback} onKeyPress={toggleCallback}>
        <Styled.Icon height={18} width={18} />
        Read me before booking installation or recycling
      </Styled.Link>
      <ServiceInformationQuickView {...{ show, toggleCallback }} />
    </ErrorBoundary>
  )
}

export default ServicePicker
